import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';

import { MainWindowComponent } from './layouts/main-window/main-window.component';
import { ResetPassComponent } from './component/Actions/reset-pass/reset-pass.component';
import { ForgotPassComponent } from './component/Actions/forgot-pass/forgot-pass.component';
import { LoginComponent } from './component/login/login.component';
import { AddEventlogsComponent } from './component/EventLogs/add-eventlogs/add-eventlogs/add-eventlogs.component';
import { EditEventlogsComponent } from './component/EventLogs/edit-eventlogs/edit-eventlogs/edit-eventlogs.component';
import { ListEventlogsComponent } from './component/EventLogs/list-eventlogs/list-eventlogs/list-eventlogs.component';
import { ComparasiongraphComponent } from './component/Graphs/comparasiongraph/comparasiongraph.component';
import { CustomgraphComponent } from './component/Graphs/customgraph/customgraph.component';
import { PrimarygraphComponent } from './component/Graphs/primarygraph/primarygraph.component';
import { WarrantiesGraphComponent } from './component/Graphs/warranties-graph/warranties-graph.component';
import { ListImportMapsComponent } from './component/Importmaps/list-import-maps/list-import-maps/list-import-maps.component';
import { AddOpdataComponent } from './component/Opdata/add-opdata/add-opdata.component';
import { EditOpdataComponent } from './component/Opdata/edit-opdata/edit-opdata.component';
import { ImportOpdataComponent } from './component/Opdata/import-opdata/import-opdata/import-opdata.component';
import { ListOpdataComponent } from './component/Opdata/list-opdata/list-opdata.component';
import { RawopdataListComponent } from './component/Opdata/rawopdata-list/rawopdata-list.component';
import { AddPlantComponent } from './component/Project/plants/add-plant/add-plant.component';
import { EditPlantComponent } from './component/Project/plants/edit-plant/edit-plant.component';
import { PlantsListComponent } from './component/Project/plants/plants-list/plants-list.component';
import { AddTrainComponent } from './component/Project/trains/add-train/add-train/add-train.component';
import { EditTrainComponent } from './component/Project/trains/edit-train/edit-train/edit-train.component';
import { TrainListComponent } from './component/Project/trains/train-list/train-list/train-list.component';
import { AddWarrantyComponent } from './component/Project/warrantycondition/add-warranty/add-warranty.component';
import { EditWarrantyComponent } from './component/Project/warrantycondition/edit-warranty/edit-warranty.component';
import { ListWarrantyComponent } from './component/Project/warrantycondition/list-warranty/list-warranty.component';
import { AddUserComponent } from './component/User/add-user/add-user.component';
import { EditUserComponent } from './component/User/edit-user/edit-user.component';
import { UserListComponent } from './component/User/user-list/user-list.component';
import { AddCompanyComponent } from './component/companies/add-company/add-company.component';
import { CompaniesListComponent } from './component/companies/companies-list/companies-list.component';
import { EditCompanyComponent } from './component/companies/edit-company/edit-company.component';
import { AddConductivityprofilesComponent } from './component/conductivityprofiles/add-conductivityprofiles/add-conductivityprofiles/add-conductivityprofiles.component';
import { EditConductivityprofilesComponent } from './component/conductivityprofiles/edit-conductivityprofiles/edit-conductivityprofiles/edit-conductivityprofiles.component';
import { ImportConductivityprofilesComponent } from './component/conductivityprofiles/import-conductivityprofiles/import-conductivityprofiles/import-conductivityprofiles.component';
import { ListConductivityprofilesComponent } from './component/conductivityprofiles/list-conductivityprofiles/list-conductivityprofiles/list-conductivityprofiles.component';
import { AddManufacturerComponent } from './component/manufacturers/add-manufacturer/add-manufacturer.component';
import { EditManufacturerComponent } from './component/manufacturers/edit-manufacturer/edit-manufacturer.component';
import { ManufacturersListComponent } from './component/manufacturers/manufacturers-list/manufacturers-list.component';
import { AddModelComponent } from './component/pagination/models/add-model/add-model.component';
import { EditModelComponent } from './component/pagination/models/edit-model/edit-model.component';
import { ModelsListComponent } from './component/pagination/models/models-list/models-list.component';
import { ResourcesPageComponent } from './component/Actions/resources-page/resources-page.component';
import { GraphTrainSelectorComponent } from './component/Graphs/graph-train-selector/graph-train-selector.component';
import { ConductivityprofilegraphComponent } from './component/Graphs/conductivityprofilegraph/conductivityprofilegraph.component';
import { ProfileLoaderComponent } from './component/profile-loader/profile-loader.component';
import { PassExpComponent } from './component/Actions/pass-exp/pass-exp/pass-exp.component';
import { ForgotUsernameComponent } from './component/Actions/forgot-username/forgot-username.component';

export const Approutes: Routes = [
  {
    path: '',
    component: MainWindowComponent,
    children: [
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      { path: 'login', redirectTo: '/login', pathMatch: 'full' },
      { path: 'forgot-pass', redirectTo: '/forgot-pass', pathMatch: 'full' },
      { path: 'pass-exp', redirectTo: '/pass-exp', pathMatch: 'full' },
      { path: 'forgot-username', redirectTo: '/forgot-username', pathMatch: 'full' },

      {
        path: 'dashboard',
        data: { breadcrumb: 'Home' },
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'about',
        loadChildren: () =>
          import('./about/about.module').then((m) => m.AboutModule),
      },
      {
        path: 'component',
        data: { breadcrumb: 'Home' },
        loadChildren: () =>
          import('./component/component.module').then(
            (m) => m.ComponentsModule
          ),
      },

      

      {
        path: 'companies',
        data: { breadcrumb: 'Admin / Company' },
        children: [
          { path: '', component: CompaniesListComponent },
          {
            path: 'company-add',
            data: { breadcrumb: 'Add Company' },
            component: AddCompanyComponent,
          },
          {
            path: 'edit/:id',
            data: { breadcrumb: 'Edit Company' },
            component: EditCompanyComponent,
          },
        ],
      },
      {
        path: 'models',
        data: { breadcrumb: 'Admin / Element Model' },
        children: [
          { path: '', component: ModelsListComponent },
          {
            path: 'model-add',
            data: { breadcrumb: 'Add Element Model' },
            component: AddModelComponent,
          },
          {
            path: 'edit/:id',
            data: { breadcrumb: 'Edit Element Model' },
            component: EditModelComponent,
          },
        ],
      },
      {
        path: 'user',
        data: { breadcrumb: 'Admin / User' },
        children: [
          { path: '', component: UserListComponent },
          {
            path: 'user-add',
            data: { breadcrumb: 'Add User' },
            component: AddUserComponent,
          },
          {
            path: 'edit/:id',
            data: { breadcrumb: 'Edit User' },
            component: EditUserComponent,
          },
        ],
      },
      {
        path: 'manufacturers',
        data: { breadcrumb: 'Admin / Element Manufacturer' },
        children: [
          { path: '', component: ManufacturersListComponent },
          {
            path: 'manuf-add',
            data: { breadcrumb: 'Add Element Manufacturer' },
            component: AddManufacturerComponent,
          },
          {
            path: 'edit/:id',
            data: { breadcrumb: 'Edit Element Manufacturer' },
            component: EditManufacturerComponent,
          },
        ],
      },
      {
        path: 'plants',
        //data: { breadcrumb: 'Project / Plants' },
        children: [
          { path: '', component: PlantsListComponent },
          {
            path: 'addplant',
            component: AddPlantComponent,
            //data: { breadcrumb: 'Add Plants' },
          },
          {
            path: 'edit/:id',
            component: EditPlantComponent,
            //data: { breadcrumb: 'Edit Plants' },
          },
        ],
      },
      {
        path: 'trains',
       // data: { breadcrumb: 'Train' },
        children: [
          {
            path: '',
            component: TrainListComponent,
          },
          {
            path: 'edit/:id',
           // data: { breadcrumb: 'Edit Train' },
            children: [
              {
                path: '',
                component: EditTrainComponent,
              },
              {
                path: 'primarygraph',
              //  data: { breadcrumb: 'Primary Graph' },
                component: PrimarygraphComponent,
              },
              {
                path: 'customgraph',
               // data: { breadcrumb: 'Custom Graph' },
                component: CustomgraphComponent,
              },
              {
                path: 'warrantiesgraph',
              //  data: { breadcrumb: 'Warranties Graph' },
                component: WarrantiesGraphComponent,
              },
              {
                path: 'opdata',
            //    data: { breadcrumb: 'Manage Operation Data' },
                component: ListOpdataComponent,
              },
              {
                path: 'warrantycondition',
                //data: { breadcrumb: 'Warranty Condition' },
                component: ListWarrantyComponent,
              },
            ]

          },
          {
            path: 'trains-add',
            //data: { breadcrumb: 'Add Train' },
            component: AddTrainComponent,
          },

          {
            path: 'rawopdata/:id',
            //data: { breadcrumb: 'Manage Operation Data' },
            component: RawopdataListComponent,
          },


          {
            path: 'comparisongraph',
            //data: { breadcrumb: 'Comparison Graph' },
            component: ComparasiongraphComponent,
          },
          {
            path: 'customgraph',
            //data: { breadcrumb: 'Custom Graph' },
            component: CustomgraphComponent,
          },
          {
            path: 'primarygraph',
            //data: { breadcrumb: 'Primary Graph' },
            component: PrimarygraphComponent,
          },
          

        ],
      },
      {
        path: 'graph',
       // data: { breadcrumb: 'Train' },
        children: [
          { path: '', component: GraphTrainSelectorComponent },
          {
            path: 'comparisongraph',
            //data: { breadcrumb: 'Comparison Graph' },
            component: ComparasiongraphComponent,
          },
          {
            path: 'primarygraph',
            //data: { breadcrumb: 'Primary Graph' },
            component: PrimarygraphComponent,
          },
          {
            path: 'customgraph',
            data: { breadcrumb: 'Custom Graph' },
            component: CustomgraphComponent,
          },
          {
            path: 'conductivityprofilegraph',
            //data: { breadcrumb: 'Conductivity Profile Graph' },
            component: ConductivityprofilegraphComponent,
          },
        ],
      },
      {
        path: 'profile/:id',
        component: ProfileLoaderComponent,
      },
      {
        path: 'warrantycondition',
        //data: { breadcrumb: 'Warranty Condition' },
        children: [
          { path: '', component: ListWarrantyComponent },
          {
            path: 'add-warranty',
           // data: { breadcrumb: 'Add Warranty Condition' },
            component: AddWarrantyComponent,
          },
          {
            path: 'edit/:id',
            //data: { breadcrumb: 'Edit Warranty Condition' },
            component: EditWarrantyComponent,
          },
        ],
      },
      {
        path: 'opdata',
        //data: { breadcrumb: 'Manage Operation Data' },
        children: [
          { path: '', component: ListOpdataComponent },
          {
            path: 'rawopdata',
            //data: { breadcrumb: 'Raw Operation Data' },
            component: RawopdataListComponent,
          },
          {
            path: 'opdata-add',
           // data: { breadcrumb: 'Add Operation Data' },
            component: AddOpdataComponent,
          },
          {
            path: 'edit/:id',
            //data: { breadcrumb: 'Edit Operation Data' },
            component: EditOpdataComponent,
          },
          {
            path: 'import',
            //data: { breadcrumb: 'Import Operation Data' },
            component: ImportOpdataComponent,
          },
        ],
      },

      {
        path: 'eventlogs',
        //data: { breadcrumb: 'Event Logs' },
        children: [
          { path: '', component: ListEventlogsComponent },
          {
            path: 'add-eventlogs',
            //data: { breadcrumb: 'Add Event Logs' },
            component: AddEventlogsComponent,
          },
          {
            path: 'edit/:id',
            //data: { breadcrumb: 'Edit Event Logs' },
            component: EditEventlogsComponent,
          },
        ],
      },
      {
        path: 'conductivityprofile',
        //data: { breadcrumb: 'Conductivity Profile' },
        children: [
          { path: '', component: ListConductivityprofilesComponent },
          {
            path: 'add-conductivityprofile',
            //data: { breadcrumb: 'Add Conductivity Profile' },
            component: AddConductivityprofilesComponent,
          },
          {
            path: 'edit/:id',
            //data: { breadcrumb: 'Edit Conductivity Profile' },
            component: EditConductivityprofilesComponent,
          },
          {
            path: 'import-conductivityprofile',
            //data: { breadcrumb: 'Import Conductivity Profile' },
            component: ImportConductivityprofilesComponent,
          },
        ],
      },
      {
        path: 'importmaps',
        //data: { breadcrumb: 'Manage Import Maps' },
        component: ListImportMapsComponent,
      },
    ],
  },

  { path: 'reset-pass/:actionType',  component: ResetPassComponent, },
  {
    path: '**',
    redirectTo: '/login',
  },
  
  {
    path: 'login',
    component: LoginComponent,
  },
 /*  {
    path: 'reset-pass/:actionType',
    component: ResetPassComponent,
  }, */
  {
    path: 'forgot-pass',
    component: ForgotPassComponent,
  },

  {
    path: 'pass-exp',
    component: PassExpComponent,
  },
  {
    path: 'forgot-username',
    component: ForgotUsernameComponent,
  },
];
